module.exports = __webpack_public_path__ + "static/media/excel.8c386f5a.svg";